import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionResolverService implements Resolve<any> {

  constructor(private subscriptionService: SubscriptionService,
    private sessionService: BrowserStorageService,
    private commonService: CommonService) { }

    resolve(
      route: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
    ): Observable<CurrentActivatedPlan>|Promise<CurrentActivatedPlan>| CurrentActivatedPlan {
        return this.getActivatedSubscription();
    }

  /**
   * Get activated subscription with credits
   * Fetches both subscription and credit data in parallel
   * @returns Observable of subscription with credits
   */
  getActivatedSubscription(): Observable<CurrentActivatedPlan> {
    let activateSubscription: any = {};
    if (this.sessionService.getCurrentRoles() && this.sessionService.getCurrentRoles() === 'producer') {
      return this.subscriptionService.getSubscriptionWithCredits().pipe(map((currentActivatedPlan: CurrentActivatedPlan) => {
        // Update the activeSubscription BehaviorSubject so all components get the data
        this.subscriptionService.activeSubscription.next(currentActivatedPlan);
        return currentActivatedPlan;
      }), catchError((error) => {
        this.commonService.showToastError(error);
        return of(activateSubscription);
      }) );
    } else {
      return of(activateSubscription);
    }
  }
}
